import { Typography, styled } from "@mui/material";

const TypographyStyled = styled(Typography)(() => ({
  fontSize: "16px",
  fontWeight: 500,
}));

const SubTitleUnstyled = ({ text, className, children }) => (
  <TypographyStyled className={className}>
    {typeof text !== "undefined" ? text : children}
  </TypographyStyled>
);

const SubTitle = styled(SubTitleUnstyled)({});

export default SubTitle;
